var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriorityLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.4667L17.465 7.93333C17.7503 7.64444 18.096 7.50556 18.5021 7.51667C18.9081 7.52778 19.2647 7.66667 19.572 7.93333C19.8573 8.22222 20 8.57778 20 9C20 9.42222 19.8573 9.76667 19.572 10.0333L14.107 15.6C13.5144 16.2 12.8121 16.5 12 16.5C11.1879 16.5 10.4856 16.2 9.893 15.6L4.46091 10.0333C4.15364 9.76667 4 9.42778 4 9.01667C4 8.60556 4.14266 8.24444 4.42798 7.93333C4.71331 7.64444 5.06447 7.5 5.48148 7.5C5.89849 7.5 6.24966 7.64444 6.53498 7.93333L12 13.4667Z",
    fill: "#0064CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityLow);
export default __webpack_public_path__ + "static/media/priority-low.a462f2b05148a978760d6924890a69ec.svg";
export { ForwardRef as ReactComponent };